import React, { useState, useEffect } from "react";
import { cx } from "@linaria/core";
import SliderInput from "./SliderInput";
import { SliderData } from "./Slider.styles";
const SliderHeader = ({
  sliderId,
  label,
  dualLabel,
  min,
  max,
  values,
  dualRange,
  validateAndSetValues,
  withInput,
  description
}) => {
  const [error, setError] = useState("");
  const handleError = (err) => {
    setError(err);
  };
  useEffect(() => {
    if (error)
      setError("");
  }, [values]);
  return /* @__PURE__ */ React.createElement(SliderData, {
    className: cx("sliderHeader", error && "slider--error")
  }, !dualLabel && /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__text"
  }, /* @__PURE__ */ React.createElement("div", {
    id: `${sliderId}--label`,
    className: "sliderHeader__label"
  }, label), description ? /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__description"
  }, description) : null), withInput && /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__input-wrapper"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__input-dual"
  }, error && /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__inputError"
  }, error), dualLabel ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    id: `${sliderId}--label`,
    className: "sliderHeader__label"
  }, label), description ? /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__description"
  }, description) : null) : null, /* @__PURE__ */ React.createElement(SliderInput, {
    sliderValue: values[0],
    id: `${sliderId}--input-value`,
    validRange: [min, dualRange ? values[1] : max],
    updateSlider: (val) => validateAndSetValues([val, values[1]], true),
    handleError,
    className: "sliderHeader__primaryInput"
  })), dualRange && /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__input-dual"
  }, dualLabel ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    id: `${sliderId}--label`,
    className: "sliderHeader__label"
  }, dualLabel), description ? /* @__PURE__ */ React.createElement("div", {
    className: "sliderHeader__description placeholder"
  }, description) : null) : null, /* @__PURE__ */ React.createElement(SliderInput, {
    sliderValue: values[1],
    id: `${sliderId}--secondary-input-value`,
    validRange: [values[0], max],
    updateSlider: (val) => validateAndSetValues([values[0], val], true),
    handleError,
    className: "sliderHeader__secondaryInput"
  }))));
};
export default SliderHeader;
